module.exports = __webpack_public_path__ + "omniv2/img/icon-wrench-dark.9ec68e28.svg";